import { TicketStatus, TicketType, TicketSeverity } from '../../../types/ticket';

export const TICKET_STATUS_LABELS: Record<TicketStatus, string> = {
  'To Do': 'Pendiente',
  'In Progress': 'En desarrollo',
  QA: 'En pruebas',
  Done: 'Completado',
};

export const TICKET_TYPE_LABELS: Record<TicketType, string> = {
  bug: 'Error',
  feature: 'Mejoras',
  modification: 'Modificación',
};

export const TICKET_SEVERITY_LABELS: Record<TicketSeverity, string> = {
  low: 'Baja',
  medium: 'Media',
  high: 'Alta',
  critical: 'Crítica',
};
